var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowLeftSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2048 2048",
    style: {
      enableBackground: "new 0 0 2048 2048"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2C2E3E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M612.8,1024.1c170-170.5,340.8-341.7,511.2-512.6c50.1,50.1,100,100,150.1,150.1 c-120.6,120.5-241.5,241.5-362.7,362.7c121.5,121.5,242.4,242.3,363,363c-50.1,50.1-100,100-150,150 C953.9,1366.2,783.1,1194.9,612.8,1024.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeftSecondary);
export default __webpack_public_path__ + "static/media/iconArrowLeftSecondary.21aab3e28dc7b8e022547e9c1de2178e.svg";
export { ForwardRef as ReactComponent };